import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import TopBar from "../Components/TopBar";
import SearchBar from "../Components/SearchBar";
import BalanceCard from "../Components/BalanceCard";
import Banner from "../Components/Banner";
import LeagueTabs from "../Components/LeagueTabs";
import MatchList from "../Components/MatchList";

import {
  FaTelegramPlane,
  FaWhatsapp,
  FaUsers,
  FaBullhorn,
} from "react-icons/fa";

import {
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase";
import "./Dashboard.css";

// Bandika const translations = { ... }; hapa juu ya Dashboard

const translations = {
  en: {
    estimatedBalance: "Estimated Balance",
    todaysProfit: "Today's Profit",
    deposit: "Deposit",
    marketTrade: "MarketTrade",
    showUsername: "Show username",
    hideUsername: "Hide username",
    joinTelegram: "Join Telegram",
    whatsappChannel: "WhatsApp Channel",
    followChannel: "Follow Channel",
    joinGroup: "Join Group",
  },
  fr: {
    estimatedBalance: "Solde estimé",
    todaysProfit: "Profit du jour",
    deposit: "Dépôt",
    marketTrade: "Marché",
    showUsername: "Afficher le nom d'utilisateur",
    hideUsername: "Masquer le nom d'utilisateur",
    joinTelegram: "Rejoindre Telegram",
    whatsappChannel: "Chaîne WhatsApp",
    followChannel: "Suivre la chaîne",
    joinGroup: "Rejoindre le groupe",
  },
  sw: {
    estimatedBalance: "Salio Linalokadiriwa",
    todaysProfit: "Faida ya Leo",
    deposit: "Weka Pesa",
    marketTrade: "Soko",
    showUsername: "Onyesha jina la mtumiaji",
    hideUsername: "Ficha jina la mtumiaji",
    joinTelegram: "Jiunge na Telegram",
    whatsappChannel: "Kituo cha WhatsApp",
    followChannel: "Fuata Kituo",
    joinGroup: "Jiunge na Kikundi",
  },
  pt: {
    estimatedBalance: "Saldo Estimado",
    todaysProfit: "Lucro de Hoje",
    deposit: "Depositar",
    marketTrade: "Mercado",
    showUsername: "Mostrar nome de usuário",
    hideUsername: "Ocultar nome de usuário",
    joinTelegram: "Entrar no Telegram",
    whatsappChannel: "Canal do WhatsApp",
    followChannel: "Seguir Canal",
    joinGroup: "Entrar no Grupo",
  },
  es: {
    estimatedBalance: "Saldo estimado",
    todaysProfit: "Ganancias de hoy",
    deposit: "Depositar",
    marketTrade: "Mercado",
    showUsername: "Mostrar nombre de usuario",
    hideUsername: "Ocultar nombre de usuario",
    joinTelegram: "Unirse a Telegram",
    whatsappChannel: "Canal de WhatsApp",
    followChannel: "Seguir canal",
    joinGroup: "Unirse al grupo",
  },
  ar: {
    estimatedBalance: "الرصيد التقديري",
    todaysProfit: "أرباح اليوم",
    deposit: "إيداع",
    marketTrade: "السوق",
    showUsername: "إظهار اسم المستخدم",
    hideUsername: "إخفاء اسم المستخدم",
    joinTelegram: "انضم إلى تيليجرام",
    whatsappChannel: "قناة واتساب",
    followChannel: "تابع القناة",
    joinGroup: "انضم إلى المجموعة",
  },
  zh: {
    estimatedBalance: "预计余额",
    todaysProfit: "今日收益",
    deposit: "存款",
    marketTrade: "市场",
    showUsername: "显示用户名",
    hideUsername: "隐藏用户名",
    joinTelegram: "加入 Telegram",
    whatsappChannel: "WhatsApp 频道",
    followChannel: "关注频道",
    joinGroup: "加入群组",
  },
  hi: {
    estimatedBalance: "अनुमानित बैलेंस",
    todaysProfit: "आज का लाभ",
    deposit: "जमा करें",
    marketTrade: "बाज़ार",
    showUsername: "उपयोगकर्ता नाम दिखाएँ",
    hideUsername: "उपयोगकर्ता नाम छिपाएँ",
    joinTelegram: "टेलीग्राम से जुड़ें",
    whatsappChannel: "व्हाट्सऐप चैनल",
    followChannel: "चैनल फ़ॉलो करें",
    joinGroup: "ग्रुप से जुड़ें",
  },
  bn: {
    estimatedBalance: "আনুমানিক ব্যালেন্স",
    todaysProfit: "আজকের লাভ",
    deposit: "জমা দিন",
    marketTrade: "বাজার",
    showUsername: "ব্যবহারকারীর নাম দেখান",
    hideUsername: "ব্যবহারকারীর নাম লুকান",
    joinTelegram: "টেলিগ্রামে যোগ দিন",
    whatsappChannel: "হোয়াটসঅ্যাপ চ্যানেল",
    followChannel: "চ্যানেল অনুসরণ করুন",
    joinGroup: "গ্রুপে যোগ দিন",
  },
  ru: {
    estimatedBalance: "Расчётный баланс",
    todaysProfit: "Прибыль за сегодня",
    deposit: "Пополнить",
    marketTrade: "Рынок",
    showUsername: "Показать имя пользователя",
    hideUsername: "Скрыть имя пользователя",
    joinTelegram: "Присоединиться к Telegram",
    whatsappChannel: "Канал WhatsApp",
    followChannel: "Подписаться на канал",
    joinGroup: "Вступить в группу",
  },
  de: {
    estimatedBalance: "Geschätztes Guthaben",
    todaysProfit: "Heutiger Gewinn",
    deposit: "Einzahlen",
    marketTrade: "Markt",
    showUsername: "Benutzernamen anzeigen",
    hideUsername: "Benutzernamen verbergen",
    joinTelegram: "Telegram beitreten",
    whatsappChannel: "WhatsApp-Kanal",
    followChannel: "Kanal folgen",
    joinGroup: "Gruppe beitreten",
  },
  it: {
    estimatedBalance: "Saldo stimato",
    todaysProfit: "Profitto di oggi",
    deposit: "Deposita",
    marketTrade: "Mercato",
    showUsername: "Mostra nome utente",
    hideUsername: "Nascondi nome utente",
    joinTelegram: "Unisciti a Telegram",
    whatsappChannel: "Canale WhatsApp",
    followChannel: "Segui il canale",
    joinGroup: "Unisciti al gruppo",
  },
  nl: {
    estimatedBalance: "Geschat saldo",
    todaysProfit: "Winst van vandaag",
    deposit: "Storten",
    marketTrade: "Markt",
    showUsername: "Gebruikersnaam tonen",
    hideUsername: "Gebruikersnaam verbergen",
    joinTelegram: "Word lid van Telegram",
    whatsappChannel: "WhatsApp-kanaal",
    followChannel: "Kanaal volgen",
    joinGroup: "Word lid van de groep",
  },
  tr: {
    estimatedBalance: "Tahmini Bakiye",
    todaysProfit: "Bugünkü Kâr",
    deposit: "Para Yatır",
    marketTrade: "Piyasa",
    showUsername: "Kullanıcı adını göster",
    hideUsername: "Kullanıcı adını gizle",
    joinTelegram: "Telegram'a Katıl",
    whatsappChannel: "WhatsApp Kanalı",
    followChannel: "Kanalı Takip Et",
    joinGroup: "Gruba Katıl",
  },
  ja: {
    estimatedBalance: "推定残高",
    todaysProfit: "本日の利益",
    deposit: "入金",
    marketTrade: "マーケット",
    showUsername: "ユーザー名を表示",
    hideUsername: "ユーザー名を隠す",
    joinTelegram: "Telegramに参加",
    whatsappChannel: "WhatsAppチャンネル",
    followChannel: "チャンネルをフォロー",
    joinGroup: "グループに参加",
  },
  ko: {
    estimatedBalance: "예상 잔액",
    todaysProfit: "오늘의 수익",
    deposit: "입금",
    marketTrade: "마켓",
    showUsername: "사용자 이름 표시",
    hideUsername: "사용자 이름 숨기기",
    joinTelegram: "텔레그램 참여",
    whatsappChannel: "WhatsApp 채널",
    followChannel: "채널 팔로우",
    joinGroup: "그룹 참여",
  },
  vi: {
    estimatedBalance: "Số dư ước tính",
    todaysProfit: "Lợi nhuận hôm nay",
    deposit: "Nạp tiền",
    marketTrade: "Thị trường",
    showUsername: "Hiện tên người dùng",
    hideUsername: "Ẩn tên người dùng",
    joinTelegram: "Tham gia Telegram",
    whatsappChannel: "Kênh WhatsApp",
    followChannel: "Theo dõi kênh",
    joinGroup: "Tham gia nhóm",
  },
  th: {
    estimatedBalance: "ยอดเงินโดยประมาณ",
    todaysProfit: "กำไรวันนี้",
    deposit: "ฝากเงิน",
    marketTrade: "ตลาด",
    showUsername: "แสดงชื่อผู้ใช้",
    hideUsername: "ซ่อนชื่อผู้ใช้",
    joinTelegram: "เข้าร่วม Telegram",
    whatsappChannel: "ช่อง WhatsApp",
    followChannel: "ติดตามช่อง",
    joinGroup: "เข้าร่วมกลุ่ม",
  },
  id: {
    estimatedBalance: "Saldo Perkiraan",
    todaysProfit: "Keuntungan Hari Ini",
    deposit: "Deposit",
    marketTrade: "Pasar",
    showUsername: "Tampilkan nama pengguna",
    hideUsername: "Sembunyikan nama pengguna",
    joinTelegram: "Bergabung dengan Telegram",
    whatsappChannel: "Saluran WhatsApp",
    followChannel: "Ikuti Saluran",
    joinGroup: "Gabung Grup",
  },
  ms: {
    estimatedBalance: "Baki Anggaran",
    todaysProfit: "Keuntungan Hari Ini",
    deposit: "Deposit",
    marketTrade: "Pasaran",
    showUsername: "Tunjukkan nama pengguna",
    hideUsername: "Sembunyikan nama pengguna",
    joinTelegram: "Sertai Telegram",
    whatsappChannel: "Saluran WhatsApp",
    followChannel: "Ikuti Saluran",
    joinGroup: "Sertai Kumpulan",
  },
  ur: {
    estimatedBalance: "تخمینی بیلنس",
    todaysProfit: "آج کا منافع",
    deposit: "رقم جمع کریں",
    marketTrade: "مارکیٹ",
    showUsername: "صارف کا نام دکھائیں",
    hideUsername: "صارف کا نام چھپائیں",
    joinTelegram: "ٹیلیگرام میں شامل ہوں",
    whatsappChannel: "واٹس ایپ چینل",
    followChannel: "چینل فالو کریں",
    joinGroup: "گروپ میں شامل ہوں",
  },
  fa: {
    estimatedBalance: "موجودی تخمینی",
    todaysProfit: "سود امروز",
    deposit: "واریز",
    marketTrade: "بازار",
    showUsername: "نمایش نام کاربری",
    hideUsername: "پنهان کردن نام کاربری",
    joinTelegram: "پیوستن به تلگرام",
    whatsappChannel: "کانال واتساپ",
    followChannel: "دنبال کردن کانال",
    joinGroup: "پیوستن به گروه",
  },
  ha: {
    estimatedBalance: "Ma'aunin Kuɗi",
    todaysProfit: "Ribar Yau",
    deposit: "Ajiye Kuɗi",
    marketTrade: "Kasuwa",
    showUsername: "Nuna sunan mai amfani",
    hideUsername: "Ɓoye sunan mai amfani",
    joinTelegram: "Shiga Telegram",
    whatsappChannel: "Tashar WhatsApp",
    followChannel: "Bi Tashar",
    joinGroup: "Shiga Ƙungiya",
  },
  yo: {
    estimatedBalance: "Ìwọ̀n Owó",
    todaysProfit: "Èrè Òní",
    deposit: "Fi Owó Sílẹ̀",
    marketTrade: "Ọjà",
    showUsername: "Fi orúkọ olumulo hàn",
    hideUsername: "Fi orúkọ olumulo pamọ́",
    joinTelegram: "Darapọ mọ Telegram",
    whatsappChannel: "Ikanni WhatsApp",
    followChannel: "Tẹle Ikanni",
    joinGroup: "Darapọ mọ Ẹgbẹ",
  },
  zu: {
    estimatedBalance: "Ibhalansi Elinganiselwe",
    todaysProfit: "Inzuzo Yanamuhla",
    deposit: "Faka Imali",
    marketTrade: "Imakethe",
    showUsername: "Bonisa igama lomsebenzisi",
    hideUsername: "Fihla igama lomsebenzisi",
    joinTelegram: "Joyina iTelegram",
    whatsappChannel: "Isiteshi se-WhatsApp",
    followChannel: "Landela Isiteshi",
    joinGroup: "Joyina Iqembu",
  },
  am: {
    estimatedBalance: "የተገመተ ቀሪ ሂሳብ",
    todaysProfit: "የዛሬ ትርፍ",
    deposit: "ገንዘብ አስገባ",
    marketTrade: "ገበያ",
    showUsername: "የተጠቃሚ ስም አሳይ",
    hideUsername: "የተጠቃሚ ስም ደብቅ",
    joinTelegram: "ቴሌግራምን ይቀላቀሉ",
    whatsappChannel: "የዋትስአፕ ቻናል",
    followChannel: "ቻናሉን ይከተሉ",
    joinGroup: "ቡድኑን ይቀላቀሉ",
  },
  so: {
    estimatedBalance: "Hadhaaga La Qiyaasay",
    todaysProfit: "Faa'iidada Maanta",
    deposit: "Lacag Dhigasho",
    marketTrade: "Suuqa",
    showUsername: "Muuji magaca isticmaalaha",
    hideUsername: "Qari magaca isticmaalaha",
    joinTelegram: "Ku Biir Telegram",
    whatsappChannel: "Kanaalka WhatsApp",
    followChannel: "Raac Kanaalka",
    joinGroup: "Ku Biir Kooxda",
  },
  rw: {
    estimatedBalance: "Amafaranga Agenewe",
    todaysProfit: "Inyungu y'Uyu Munsi",
    deposit: "Shyiramo Amafaranga",
    marketTrade: "Isoko",
    showUsername: "Erekana izina ry'ukoresha",
    hideUsername: "Hisha izina ry'ukoresha",
    joinTelegram: "Injira muri Telegram",
    whatsappChannel: "Umuyoboro wa WhatsApp",
    followChannel: "Kurikira Umuyoboro",
    joinGroup: "Injira mu Itsinda",
  },
  lg: {
    estimatedBalance: "Ssente Ezibaliriddwa",
    todaysProfit: "Amagoba g'Olwaleero",
    deposit: "Teekamu Ssente",
    marketTrade: "Akataale",
    showUsername: "Laga erinnya ly'omukozesa",
    hideUsername: "Kweka erinnya ly'omukozesa",
    joinTelegram: "Weegatte ku Telegram",
    whatsappChannel: "Omukutu gwa WhatsApp",
    followChannel: "Goberera Omukutu",
    joinGroup: "Weegatte mu Kibiina",
  },
  af: {
    estimatedBalance: "Geskatte balans",
    todaysProfit: "Vandag se wins",
    deposit: "Deponeer",
    marketTrade: "Mark",
    showUsername: "Wys gebruikersnaam",
    hideUsername: "Versteek gebruikersnaam",
    joinTelegram: "Sluit aan by Telegram",
    whatsappChannel: "WhatsApp-kanaal",
    followChannel: "Volg kanaal",
    joinGroup: "Sluit aan by groep",
  },
};


const Dashboard = () => {
  const navigate = useNavigate();

  // LANGUAGE
  const [language, setLanguage] = useState(
    () => localStorage.getItem("language") || "en"
  );

  useEffect(() => {
    const updateLanguage = () => {
      setLanguage(localStorage.getItem("language") || "en");
    };

    window.addEventListener("languageChanged", updateLanguage);
    window.addEventListener("storage", updateLanguage);

    return () => {
      window.removeEventListener("languageChanged", updateLanguage);
      window.removeEventListener("storage", updateLanguage);
    };
  }, []);

  const t = translations[language] || translations.en;

  const [telegramLink, setTelegramLink] = useState("");
  const [whatsappLink, setWhatsappLink] = useState("");
  const [whatsAppItems, setWhatsAppItems] = useState([]);

  // AUTO LOGOUT AFTER 30 MINUTES OF INACTIVITY
  useEffect(() => {
    let timer;

    const logout = () => {
      localStorage.clear();
      navigate("/login");
    };

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(logout, 30 * 60 * 1000);
    };

    resetTimer();

    window.addEventListener("click", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("scroll", resetTimer);
    window.addEventListener("touchstart", resetTimer);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("click", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("scroll", resetTimer);
      window.removeEventListener("touchstart", resetTimer);
    };
  }, [navigate]);

  // LOAD TELEGRAM AND WHATSAPP LINKS
  useEffect(() => {
    let cancelled = false;

    const fetchLinks = async () => {
      try {
        const telegramSnapshot = await getDocs(
          collection(db, "telegram")
        );

        let telegram = "";

        telegramSnapshot.forEach((item) => {
          if (item.data().link) {
            telegram = item.data().link;
          }
        });

        const whatsappSnapshot = await getDocs(
          collection(db, "whatsupp")
        );

        let whatsapp = "";

        whatsappSnapshot.forEach((item) => {
          if (item.data().link) {
            whatsapp = item.data().link;
          }
        });

        if (!cancelled) {
          setTelegramLink(telegram);
          setWhatsappLink(whatsapp);
        }
      } catch (error) {
        console.error("Error loading social links:", error);
      }
    };

    fetchLinks();

    return () => {
      cancelled = true;
    };
  }, []);

  // LOAD ACTIVE WHATSAPP GROUPS AND CHANNELS
  useEffect(() => {
    let cancelled = false;

    const fetchWhatsAppItems = async () => {
      try {
        const q = query(
          collection(db, "whatsupgroup"),
          where("active", "==", true)
        );

        const snapshot = await getDocs(q);

        const items = snapshot.docs
          .map((item) => ({
            id: item.id,
            ...item.data(),
          }))
          .filter((item) => {
            if (typeof item.whatsappLink !== "string") {
              return false;
            }

            try {
              const url = new URL(item.whatsappLink.trim());

              if (url.protocol !== "https:") {
                return false;
              }

              if (item.type === "channel") {
                return (
                  ["whatsapp.com", "www.whatsapp.com"].includes(
                    url.hostname
                  ) &&
                  /^\/channel\/[A-Za-z0-9_-]+\/?$/.test(
                    url.pathname
                  )
                );
              }

              if (!item.type || item.type === "community") {
                return (
                  url.hostname === "chat.whatsapp.com" &&
                  /^\/[A-Za-z0-9]+\/?$/.test(url.pathname)
                );
              }

              return false;
            } catch {
              return false;
            }
          });

        if (!cancelled) {
          setWhatsAppItems(items);
        }
      } catch (error) {
        console.error(
          "Error loading WhatsApp groups/channels:",
          error
        );

        if (!cancelled) {
          setWhatsAppItems([]);
        }
      }
    };

    fetchWhatsAppItems();

    return () => {
      cancelled = true;
    };
  }, []);

  // OPEN VALID WHATSAPP GROUP OR CHANNEL
  const openWhatsAppLink = (item) => {
    try {
      const url = new URL(item.whatsappLink.trim());

      const isChannel =
        item.type === "channel" &&
        url.protocol === "https:" &&
        ["whatsapp.com", "www.whatsapp.com"].includes(
          url.hostname
        ) &&
        /^\/channel\/[A-Za-z0-9_-]+\/?$/.test(url.pathname);

      const isGroup =
        (!item.type || item.type === "community") &&
        url.protocol === "https:" &&
        url.hostname === "chat.whatsapp.com" &&
        /^\/[A-Za-z0-9]+\/?$/.test(url.pathname);

      if (isChannel || isGroup) {
        window.open(url.href, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("Invalid WhatsApp link:", error);
    }
  };

  return (
    <div className="dashboard">
      <TopBar />

      <div className="dashboard-content">
        <SearchBar />

        <BalanceCard />

        <Banner />

        {/* TELEGRAM AND WHATSAPP LINKS */}
        <div className="social-section">
          {telegramLink && (
            <a
              href={telegramLink}
              target="_blank"
              rel="noopener noreferrer"
              className="telegram-btn"
            >
              <FaTelegramPlane />
              <span>{t.joinTelegram}</span>
            </a>
          )}

          {whatsappLink && (
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn"
            >
              <FaWhatsapp />
              <span>{t.whatsappChannel}</span>
            </a>
          )}
        </div>

        {/* WHATSAPP GROUPS AND CHANNELS */}
        {whatsAppItems.length > 0 && (
          <div className="dashboard-whatsapp-section">
            {whatsAppItems.map((item) => {
              const isChannel = item.type === "channel";

              return (
                <button
                  key={item.id}
                  type="button"
                  className={`dashboard-whatsapp-btn ${
                    isChannel ? "channel-btn" : "group-btn"
                  }`}
                  onClick={() => openWhatsAppLink(item)}
                >
                  {isChannel ? <FaBullhorn /> : <FaUsers />}

                  <span>
                    {isChannel
                      ? t.followChannel
                      : t.joinGroup}
                  </span>

                  <FaWhatsapp className="dashboard-whatsapp-icon" />
                </button>
              );
            })}
          </div>
        )}

        {/* LEAGUES */}
        <div className="section">
          <LeagueTabs />
        </div>

        {/* MATCHES */}
        <div className="section">
          <MatchList />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;